import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=2a35a7d8&"
import script from "./PageHeading.vue?vue&type=script&lang=ts&"
export * from "./PageHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports